import * as React from 'react';

import {setBodyId} from '../../../dom';

import {PageContainer, PageTitleBar} from '../../layout';
import {mountSettingsSidebar} from '../../setup/mount-settings-sidebar';
import {mountSenderAddressMigrationBanner} from '../../setup/sender-address/mount-sender-address-migration-banner';
import {SetupPage} from '../../setup/setup-page';

type Props = {
    search: string;
};
/**
 * Wrapper for the sender addresses page that allows it to render as a complete
 * page outside of the setup context. We use this for the version in the marketing tab
 */
export function SenderAddressesPageStandalone(props: Props) {
    setBodyId('list-sender-address');

    return (
        <PageContainer
            title='Sender addresses'
            noPadding={true}
            pageTitleBar={
                <PageTitleBar
                    title='Sender addresses'
                    subheaderPrimaryText='Use these email addresses to send outreach to your contacts'
                />
            }
        >
            <SetupPage
                pageTitle='Sender addresses'
                viewUrl={'/setup/sender-address'}
                viewParams={props.search}
                onViewRendered={() => {
                    mountSenderAddressMigrationBanner();
                    mountSettingsSidebar();
                }}
            />
        </PageContainer>
    );
}
